import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Button,
  InputAdornment,
  TextField,
} from "@mui/material";
import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { useSearchParams } from "react-router-dom";
import { IPurchaseOrder } from "./IPurchaseOrder";

import {
  clearListPurchaseOrder,
  listPurchaseOrderStart,
} from "../../redux/purchase-order/listPurchaseOrder";
import PurchaseOrderList from "./PurchaseOrderList";
import "../../assets/css/purchaseorder/purchaseorder.css";
import {
  clearSyncPurchaseOrder,
  syncPurchaseOrderStart,
} from "../../redux/purchase-order/syncPurchaseOrder";
import { dateFormate } from "../../Utils/date-month-yearFromatter";
import SearchImg from "../../assets/images/search.svg";
import { useCommonContext } from "../../Utils/commonContext";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { toast } from "react-toastify";

const statusItems = [
  {
    className: "approve_sts",
    label: "approved",
  },
  { className: "reject_sts", label: "reject" },
  {
    className: "request_sts",
    label: "pending",
  },
];

const statusOrder = ["Pending for Approval", "Approved", "Rejected", "Unknown"];

const PurchaseOrder: FunctionComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [purchaseOrder, setPurchaseOrder] = useState<IPurchaseOrder>({});
  const [search, setSearch] = useState<string>("");
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  const dispatch = useAppDispatch();

  const { data: purchaseOrderList, isLoading: purchaseOrderLoading } =
    useAppSelector((state) => state.ListPurchaseOrder);

  const { data: syncPurchase, isLoading: loadSyncPurchase } = useAppSelector(
    (state) => state.SyncPurchaseOrder
  );
  console.log("SyncPurchase", syncPurchase?.status);

  const { data: editPurchaseOrder, isLoading: editPurchaseOrderLoading } =
    useAppSelector((state) => state.EditPurchaseOrder);
  const listPurchaseOrder =
    purchaseOrderList?.result?.map((retailer, index) => ({
      ...retailer,
      index: index + 1,
    })) ?? [];
  const [expanded, setExpanded] = useState<string | false>("panel1");

  const handleAccChange =
    (panel: string) => (event: any, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  console.log("listPurchaseOrder", listPurchaseOrder);

  // list render
  useEffect(() => {
    if (editPurchaseOrder) {
      dispatch(listPurchaseOrderStart(null));
    }
  }, [editPurchaseOrder]);

  useEffect(() => {
    if (listPurchaseOrder?.length !== 0) {
      const purchaseOrderCheckById =
        searchParams.get("id") &&
        listPurchaseOrder?.find(
          (purchaseOrder) =>
            Number(purchaseOrder.id) === Number(searchParams.get("id"))
        );

      const test = listPurchaseOrder?.find(
        (val) => val.id === Number(searchParams.get("id"))
      );

      console.log("val.id", typeof listPurchaseOrder[0].id);

      console.log("get.id", typeof searchParams.get("id"));

      console.log("purchaseOrderCheckById", purchaseOrderCheckById);

      if (purchaseOrderCheckById) {
        setPurchaseOrder(purchaseOrderCheckById);
      } else {
        setPurchaseOrder({});
      }
    }
  }, [
    searchParams.get("id"),
    listPurchaseOrder?.length,
    // createRetailer,
    // editRetailer,
  ]);

  useEffect(() => {
    if (syncPurchase?.status) {
      toast.success("Purchase Order SAP data fetched successfully.");
      dispatch(listPurchaseOrderStart(null));
    } else if (syncPurchase?.status === false) {
      toast.error("Unable to fetch Purchase Order SAP data");
      dispatch(listPurchaseOrderStart(null));
    }
  }, [syncPurchase]);

  const handleBack = () => {
    setPurchaseOrder({});
    setShowBack(false);
    setTitleContext("Purchase Order");
  };

  console.log("purchaseOrder2", syncPurchase);

  useEffect(() => {
    dispatch(syncPurchaseOrderStart(null));
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearListPurchaseOrder());
      dispatch(clearSyncPurchaseOrder());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (purchaseOrder?.CardName) {
      setShowBack(true);
    }
  }, [purchaseOrder]);

  useEffect(() => {
    setTitleContext(purchaseOrder?.CardName ?? "Purchase Order");
  }, [purchaseOrder]);

  const statusClassName = (value: string) => {
    return statusItems.find((it) =>
      value.trim().toLocaleLowerCase().includes(it.label)
    )?.className;
  };

  const groupedDataBase = listPurchaseOrder
    ? listPurchaseOrder
        ?.filter((item: any) =>
          Object.values(item)
            .join("")
            .toLowerCase()
            .includes(search.toLowerCase())
        )
        .reduce((acc: any, item: any) => {
          const st = item.approval_status_text || "Others";
          if (!acc[st]) acc[st] = [];
          acc[st].push(item);
          return acc;
        }, {})
    : [];

  const groupedData = statusOrder.map((status) => ({
    status,
    items: groupedDataBase[status] || [],
  }));

  return (
    <div className="partner-details">
      <div className={`content_container`}>
        <div
          className={`mini_side_container`}
          style={{
            display: isMobile && purchaseOrder.id ? "none" : "initial",
          }}
        >
          <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
            Purchase Order
          </h5>

          <div className="side_search_container">
            <TextField
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Search"
              className="side_search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchImg} alt="search" width="20px" />
                  </InputAdornment>
                ),
                style: {
                  borderRadius: "0px",
                  height: "45px",
                },
              }}
            />
            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                dispatch(syncPurchaseOrderStart(null));
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "arrows-rotate"]}
              />
            </Button>
          </div>

          <div className="side_content_container">
            {groupedData.map((group, index) => (
              <Fragment>
                {group.items.length > 0 && (
                  <Accordion
                    key={group.status}
                    className="business_partner_acc"
                    expanded={expanded === `panel${index + 1}`}
                    onChange={handleAccChange(`panel${index + 1}`)}
                  >
                    <AccordionSummary
                      className={`${statusClassName(group.status)}`}
                      expandIcon={<FontAwesomeIcon icon="caret-down" />}
                    >
                      <h4 className={`f5`}>{group.status}</h4>
                    </AccordionSummary>

                    <AccordionDetails>
                      {group.items.map((val: any, key: any) => (
                        <div
                          key={key + 1}
                          className={`side_content_card`}
                          onClick={() => {
                            val.id &&
                              setSearchParams({ id: val.id?.toString() });
                          }}
                        >
                          <div
                            className={`side_content_mini_card ${
                              purchaseOrder.id === val.id ? "active" : ""
                            }`}
                          >
                            <div className="side_content_footer">
                              <div className="f4 title">{val.CardName}</div>
                            </div>
                            <div className="side_content_footer side_content_footer2">
                              <h4 className="f4 subtitle">
                                {val.DocDate && dateFormate(val.DocDate)}
                              </h4>
                              <div className="f5">
                                {val.Currency}{" "}
                                {Number(val.DocTotal).toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                )}
              </Fragment>
            ))}
          </div>
        </div>

        <div
          className={`mini_content_container`}
          style={{
            display: isMobile && !purchaseOrder.id ? "none" : "initial",
          }}
        >
          {Object.keys(purchaseOrder).length === 0 ? (
            <div className="not_found_container">
              <img src={DataNotFound} alt="" />
              Please Select Any One Purchase Order
            </div>
          ) : (
            <PurchaseOrderList purchaseOrder={purchaseOrder} />
          )}
        </div>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!!purchaseOrderLoading || !!loadSyncPurchase}
      >
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>
    </div>
  );
};

export default PurchaseOrder;
